
export const AssignInvoiceCriteriaConstant = {
    TITLE: "Assign Invoice Criteria Maintenance",
    BILL_TO_COMPANY: "Bill-To Company",
    TARIFF_TYPE: "Tariff Type",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    CONTAINER_STATUS: "Container Status",
    CONTAINER_SIZE: "Container Size",
    SHIPMENT_TYPE: "Shipment Type",
    CUSTOMER_CODE: "Customer Code",
    DOC_DATE_RANGE: "Doc Date Range",
    OPS_DATE_RANGE: "Ops Date Range",
    GL_DATE_RANGE: "GL Date Range",
}
